module.exports = __webpack_public_path__ + "img/layout-text-sidebar-reverse.81aef55e.svg";